import React from "react";
import { VIOptionCard } from "./viOptionCard";
import { useTheme } from "context/ThemeContext";
import LightBg from "images/virtual-internship/bg-light-illustration.png";
import DarkBg from "images/virtual-internship/bg-dark-illustration.png";
import { ConditionalSwiper } from "../shared/conditionalSwiper";
import { useBreakpoint } from "hooks/useBreakpoint";
export const VIOptionCardList = ({ viWhatYouGetTitle, viWhatYouGet }) => {
  const { colorMode } = useTheme();
  const breakpoint = useBreakpoint();
  return (
    <section
      className="relative w-full flex justify-center overflow-hidden bg-white dark:bg-gray-dark"
      style={{
        backgroundImage: `url('${colorMode === "light" ? LightBg : DarkBg}')`
      }}
    >
      <div className="gvi-container mx-auto pt-12 pb-10 md:pt-20 md:pb-24">
        <h1 className="pb-6 md:pb-11 !font-normal md:!font-light">
          {viWhatYouGetTitle}
        </h1>
        <div className="issues-swiper-container grid grid-cols-1 md:grid-cols-2 gap-y-14 md:gap-y-9 md:gap-x-32 pt-0 md:pt-0 md:pl-11 w-full">
          <ConditionalSwiper
            condition={breakpoint === "xs"}
            slidesPerView={1.15}
            spaceBetween={20}
            centeredSlides={false}
            pagination={true}
            className="w-full h-102 md:h-full"
          >
            {viWhatYouGet?.map((data, index) => {
              const iconImage = data?.whatYouGetIcon?.localFile;
              const iconSourceUrl = data?.whatYouGetIcon?.sourceUrl;
              const title = data.title;
              const description = data.description;
              const bgLogoImage = data?.logo?.localFile;
              const logoFallbackImage = data?.logo?.sourceUrl;
              return (
                <VIOptionCard
                  fallbackIcon={iconSourceUrl}
                  iconImg={iconImage}
                  title={title}
                  description={description}
                  logoFallbackImage={logoFallbackImage}
                  bgLogoImage={bgLogoImage}
                  key={index}
                />
              );
            })}
          </ConditionalSwiper>
        </div>
      </div>
    </section>
  );
};
